import { useEffect, useState } from "react";
import { api } from "./api";

// Fetch the admin-configurable app version label (shown inside the app).
export function useAppVersion() {
  const [version, setVersion] = useState("1.0");
  useEffect(() => {
    api("/app-settings").then((r) => setVersion(r?.version_name || "1.0")).catch(() => {});
  }, []);
  return version;
}
